<template>
  <div style=" background-color: #fff;padding-bottom: 40px;">
    <div class="headersts">
      <img src="../../assets/images/home/logo.png" class="imgsts" alt @click="retrungo()" />
      <span style="cursor: pointer;margin-left:5px" @click="retrungo()">{{biaoTi}}</span>
    </div>
    <!-- 导航标签 -->
    <div class="cate">
      <div class="cate_police">
        <div class="cate-all">等级：</div>
        <div class="subject">
          <span
            v-for="(item, index) in ResourceFormats"
            :key="index"
            :class="{heightlight : ResourceFormatsindex==index}"
            @click="ResourceFormatsArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <div class="cate_police">
        <div class="cate-all">全部警种：</div>
        <div class="subject">
          <span
            v-for="(item, index) in policeClassification"
            :key="index"
            :class="{heightlight : policeClassindex==index}"
            @click="policeClassArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <div class="cate_police">
        <div class="cate-all">地市/州 ：</div>
        <div class="subject">
          <span
            v-for="(item, index) in cityList"
            :key="index"
            :class="{heightlight : cityIndex==index}"
            @click="selectCity(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>
      <div
        class="cate_police"
        style="border-top: 1px solid #dcdfe6;margin-right: 32px;margin-left: 160px;padding-top: 20px; "
      >
        <!-- <div class="cate-all" ></div> -->
        <div class="subject" style="padding-right: 30px;">
          <span
            v-for="(item, index) in newList"
            :key="index"
            :class="{heightlight : newIndex==index}"
            @click="policeNew(index,item)"
          >{{item.name}}</span>
        </div>
        <el-input
          size="large"
          placeholder="请输入搜索内容"
          v-model="listQuerys.Name"
          class="input-with-select"
          style="width:300px; color: white;height: 40px;border-top-left-radius: 5px;border-bottom-left-radius: 5px;"
        >
          <el-button
            @click="MoocQuestionList()"
            slot="append"
            icon="el-icon-search"
            style="background: #545c63;border-top-left-radius: 0px;border-bottom-left-radius: 0px;height: 40px;color: white; font-size: 16px;"
          ></el-button>
        </el-input>
      </div>
    </div>

    <!-- 内容 -->
    <div class="box">
      <div class="trainingvideo">
        <div class="trainingvideright">
          <div
            class="trainingimgli"
            v-for="(item,index) in QuestionList"
            :key="index"
            @click="newsVideo(item.id)"
            v-if="item.documentType==2"
          >
            <img :src="item.imgUrl" />

            <div class="traingimgtext onele">{{item.name}}</div>
            <!-- <div style="padding-left:10px;padding-top:5px">
              <el-rate v-model="item.levels" disabled disabled-void-color="#cccccc"></el-rate>
            </div>-->
            <div
              style="padding-left:10px;margin-top:20px;font-size:14px;color:#888"
            >{{item.deptName}}</div>
            <div class="traingimgnametxtlil">
              <div class="traingimgname" v-if="item.jzDicName">{{item.jzDicName}}</div>

              <div class="traniBox">
                <div class="trainicon" style="margin-right:14px">
                  <img src="@/assets/resource/u231.svg" />
                  {{item.visitNum}}
                </div>
                <div class="trainicon" style="margin-right:14px">
                  <img src="@/assets/videoimg/studycommentPlin.svg" />
                  <span>{{item.talkCount}}</span>
                </div>
                <div class="trainicon">
                  <img src="@/assets/videoimg/give.svg" style="width:16px;height:16px" />
                  <span>{{item.assistCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="min-height:300px" v-else>
          <nodata></nodata>
        </div>-->
      </div>
    </div>
    <div class="pageblock">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        layout="total,prev, pager, next,jumper"
        :page-size="listQuerys.Limit"
        :current-page.sync="listQuerys.Page"
        :total="dataCount"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        v-if="dataCount>15"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getCity } from '@/api/public.js';
import * as resourceInfo from '@/api/resources/index.js';
import * as studyClassIndex from '@/api/studyClass/index';
import vHeader from '../header/index';
export default {
  components: {
    vHeader,
  },
  data() {
    return {
      biaoTi: localStorage.getItem('biaoti'),
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      newList: [
        { subType: 0, name: '最新' },
        { subType: 1, name: '最热' },
      ],
      newIndex: 0,
      pSrc: '',
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0, //高亮默认为全部
      ResourceCategories: [{ name: '全部', id: 0 }], //资源类别
      Resourceindex: 0, //高亮默认为全部
      ResourceFormats: [
        { name: '全部', id: 0 },
        { name: '五星', id: 5 },
        { name: '四星', id: 4 },
      ], //星级
      levels: 0,
      deptId: this.$route.query.deptId,
      ResourceFormatsindex: 0, //高亮默认为全部
      sortType: null, //判断数组中要对哪个值进行排序（最新则对时间进行排序，最热对点赞数进行排序）
      QuestionList: [],
      dataCount: 0,
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      listQuerys: {
        // 查询字典条件
        Page: 1,
        Limit: 15,
        Key: null,
        JzDicId: this.$route.query.jzId,
        Grade: this.$route.query.levels,
        Status: null,
        // TypeId: 1, //审核通过的显示在前端页面
        Top: null,
        Name: '',
        SortType: 0,
        deptid: null,
        Label: this.$route.query.label,
        isWK: true,
      },

      user: [], //分页数组
    };
  },
  created() {
    this.getPmiDictionary(1, this.policeClassification);
    //this.getPmiDictionary(51, this.ResourceCategories);
    this.getDishi();
    if (this.$route.query.levels) {
      //默认星级
      for (let i = 0; i < this.ResourceFormats.length; i++) {
        if (this.ResourceFormats[i].id == this.listQuerys.Grade) {
          this.ResourceFormatsindex = i;
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.title) {
      this.listQuerys.Name = decodeURIComponent(this.$route.query.title);
    }
    this.MoocQuestionList();
  },
  methods: {
    //查询新热
    policeNew(index, item) {
      this.listQuerys.SortType = index;
      this.newIndex = index;
      this.MoocQuestionList();
    },
    // 全部警种高亮索引判断
    policeClassArea(index, item) {
      this.policeClassindex = index;
      if (item.id == 0) {
        this.listQuerys.JzDicId = null;
      } else {
        this.listQuerys.JzDicId = item.id;
      }
      this.MoocQuestionList();
    },

    // 资源格式高亮索引判断
    ResourceFormatsArea(index, item) {
      this.ResourceFormatsindex = index;
      if (item.id == 0) {
        this.listQuerys.Grade = null;
      } else {
        this.listQuerys.Grade = item.id;
      }

      this.MoocQuestionList();
    },
    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
      // console.log(item);
      this.listQuerys.deptid = item.id;
      // this.listQuerys.IsChild = true;
      this.MoocQuestionList();
    },
    //获取地市
    getDishi() {
      getCity().then((res) => {
        if (this.deptId) {
          let list = res.result;
          for (let i = 0; i < list.length; i++) {
            if (list[i].id == this.deptId) {
              this.cityIndex = i + 1;
            }
          }
        }

        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
      });
    },
    retrungo() {
      this.$router.go(-1);
    },
    //获取字典数据  index代表namespaceId，arr代表传出的数组
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      resourceInfo.getPmiDic(this.listQuery).then((response) => {
        let list = response.result;
        if (this.listQuerys.JzDicId && index == 1) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].id == this.listQuerys.JzDicId) {
              this.policeClassindex = i + 1;
            }
          }
        }

        response.result.forEach((e) => {
          arr.push({ name: e.name, id: e.id });
        });
      });
    },

    // 列表
    MoocQuestionList() {
      // console.log(this.listQuerys);
      studyClassIndex.DocumentLoadList(this.listQuerys).then((res) => {
        this.QuestionList = res.data;
        this.dataCount = res.count;
      });
    },

    handleSizeChange(val) {
      this.listQuerys.Limit = val;
      this.MoocQuestionList();
    },
    handleCurrentChange(val) {
      this.listQuerys.Page = val;
      this.MoocQuestionList();
    },
    //跳转到新页面进入视频的播放
    newsVideo(id) {
      // this.$router.push('/studyclassDetail?id=' + id);
      this.$router.push('/sourceslist/videoLearn?id=' + id);
    },
  },
};
</script>
<style lang="scss" scoped>
.trainingvideo {
  padding: 24px 0;
  display: flex;
  .trainingvideright {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .trainingimgli {
      width: 228px;
      border: 1px solid rgba(242, 242, 242, 1);
      margin: 0 5px 20px 5px;
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        box-shadow: 2px 2px 6px rgb(242 242 242 / 99%);
        transform: scale(1.02);
        border-radius: 5px;
      }
      img {
        width: 100%;
        height: 136px;
        border-radius: 6px 6px 0 0;
      }
      .traingimgtext {
        font-size: 16px;
        color: #666;
        margin-top: 6px;
        padding-left: 10px;
      }
      .traingimgnametxtlil {
        color: #999;
        font-size: 14px;
        display: flex;
        margin-top: 6px;
        padding: 0 10px 10px 10px;
        .traingimgname {
          padding: 3px 5px;
          color: #fff;
          background-color: #4876c4;
          border-radius: 4px;
          font-size: 13px;
          margin-right: 8px;
        }
        .traniBox {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .trainicon {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.nav {
  width: 1200px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  margin: 0 auto;
  margin-top: 10px;
}
.nav > div {
  font-size: 19px;
  font-family: Source Han Sans CN;
  margin-left: 32px;
  padding-top: 0px;
}

/* 高亮 */
.heightlight {
  background-color: #3c95d6 !important;
  /* border: 1px solid #4876C4; */
  color: #f8fafc !important;
}
/* 资源管理内容 */
.box {
  margin: 0 auto;
  width: 1200px;
  margin-top: 20px;
  display: flex;
  min-height: 250px;
}

/* 地市 */
.rightboxfoot {
  margin-top: 32px;
  height: 510px;
}
.cityheader {
  width: 300px;
  height: 46px;
  background: #ebf1f5;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  padding-top: 12px;
}
.cityheader > div:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
  line-height: 34px;
  color: #333333;
  margin-left: 20px;
}
.cityheader > div:nth-child(2) {
  font-size: 18px;
  font-weight: bold;
  line-height: 31px;
  color: #285fbe;
  opacity: 1;
  margin-left: 80px;
}

.cate {
  width: 1180px;
  margin: 0 auto;
  margin-top: 20px;
  padding: 10px;
  /* box-shadow: 0 4px 8px 0 rgb(95 101 105 / 5%); */
}
.cate_police {
  display: flex;
  font-size: 16px;
  margin-left: 32px;
  font-family: Source Han Sans CN;
  padding: 5px 0;
}
.cate-all {
  width: 140px;
  font-weight: 700;
}
.subject {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
  opacity: 1;
  border-radius: 6px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid white;
  border-radius: 5px;
}
.subject > span:hover {
  border: 1px solid #3c95d6;
  color: #3c95d6;
  border-radius: 5px;
}

/*  */
.headersts {
  height: 60px;
  width: 100%;
  background-color: rgba(50, 65, 96, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(50, 65, 96, 1);
  border-radius: 0px;
  line-height: 60px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}

.imgsts {
  margin-left: 18%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  cursor: pointer;
}
/* 分页 样式*/
.pageblock {
  margin-top: 40px;
  text-align: center;
}

.onele {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>